// Contentful
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { RENDER_DOCUMENT_OPTIONS } from '../../helpers/contentful';

import Pattern from '../Pattern/Pattern';

const PropositionBlock = (props) => {
  const { title, items, modifiers, hidePattern } = props;

  const modifierClasses = modifiers && modifiers.length ? ` ${modifiers.join(' ')}` : '';

  return (
    <div className={`PropositionBlock${modifierClasses}`}>
      <div className="PropositionBlock-inner">
        <div className="PropositionBlock-wrapper">
          <div className="PropositionBlock-content">
            <div className="PropositionBlock-contentGrid">
              {title && <h2 className="PropositionBlock-title">{title}</h2>}
              {items?.length >= 1 && (
                <div className="PropositionBlock-items">
                  {items.map((item, index) => (
                    <div className="PropositionBlock-item" key={`PropositionBlock-item--${index}`}>
                      {item.icon && (
                        <svg className="PropositionBlock-itemIcon">
                          <use xlinkHref={`#icon-${item.icon.toLowerCase()}`} />
                        </svg>
                      )}
                      {item.title && (
                        <h3 className="PropositionBlock-itemTitle">
                          {documentToReactComponents(item.title, RENDER_DOCUMENT_OPTIONS)}
                        </h3>
                      )}
                      {item.description && (
                        <div className="PropositionBlock-itemDescription">
                          {documentToReactComponents(item.description, RENDER_DOCUMENT_OPTIONS)}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {!hidePattern && (
        <div className="PropositionBlock-pattern">
          <Pattern modifier="Pattern--pampasBeige" />
        </div>
      )}
    </div>
  );
};

export default PropositionBlock;
